export default __webpack_public_path__ + "static/media/step1.ed9fbb76.png";